import convert from 'convert-units';

export const toFixedNumber = (n, x) => {
  const pow = 10 ** x;
  return Math.round(n * pow) / pow;
};

export const inchesToMm = (n) => toFixedNumber(convert(n).from('in').to('mm'), 2);
export const mmToInches = (n) => toFixedNumber(convert(n).from('mm').to('in'), 2);
